import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    sticky: false,
  },
  getters: {
    getSticky: (state) => state.sticky,
  },
  mutations: {
    setSticky(state, payload) {
      state.sticky = payload;
    },
  },
  actions: {
  },
};
